
(function () {

  document.addEventListener('DOMContentLoaded', function () {
    const approach = document.querySelector('#approach');
    const ai = document.querySelector('#ai');

    document.addEventListener('click', function (e) {
    
    if (e.target.closest('#approach .irai')) {
      ai.classList.remove('oculto');
      approach.classList.add('oculto');
    }

    if (e.target.closest('#ai .irapproach')) {
      approach.classList.remove('oculto');
      ai.classList.add('oculto');
    }
    });
  });
  
  const canvas = document.getElementById('heroCanvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');

  let W, H, DPR = 1, spheres = [];

  function resize() {
    
    DPR = window.devicePixelRatio || 1;
    W = canvas.offsetWidth;
    H = canvas.offsetHeight;
    canvas.width  = Math.round(W * DPR);
    canvas.height = Math.round(H * DPR);
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }

  function randomBetween(a, b) { return a + Math.random() * (b - a); }

  const SIZE_POOL = [];
  for (let s = 90; s <= 220; s += 10) SIZE_POOL.push(s);

  const COLS = 5, ROWS = 3, TOTAL = COLS * ROWS;

  function Sphere(index) {
    this.r = SIZE_POOL[Math.floor(randomBetween(0, SIZE_POOL.length))];
    
    const col = index % COLS;
    const row = Math.floor(index / COLS);
    const slotW = W / COLS;
    const slotH = H / ROWS;
    this.baseX = slotW * col + slotW * 0.5 + randomBetween(-slotW * 0.25, slotW * 0.25);
    this.baseY = slotH * row + slotH * 0.5 + randomBetween(-slotH * 0.25, slotH * 0.25);
    this.x = this.baseX;
    this.y = this.baseY;
    this.phaseX = randomBetween(0, Math.PI * 2);
    this.phaseY = randomBetween(0, Math.PI * 2);
    this.freqX  = randomBetween(0.04, 0.08);   
    this.freqY  = randomBetween(0.03, 0.06);
    this.ampX   = randomBetween(12, 30);
    this.ampY   = randomBetween(8, 20);
  }

  const _sphereCache = new Map();

  function getSphereCanvas(r) {
    const key = r + ':' + DPR;
    if (_sphereCache.has(key)) return _sphereCache.get(key);

    const sizeCss = Math.ceil(r * 4.4); 
    const oc   = document.createElement('canvas');
    
    oc.width   = Math.ceil(sizeCss * DPR);
    oc.height  = Math.ceil(sizeCss * DPR);
    const oc2  = oc.getContext('2d');
    oc2.scale(DPR, DPR);
    const cx   = sizeCss / 2, cy = sizeCss / 2;

    oc2.beginPath();
    oc2.arc(cx + r * 0.15, cy + r * 0.25, r * 0.92, 0, Math.PI * 2);
    oc2.fillStyle = 'rgba(60,85,110,0.28)';
    oc2.filter = 'blur(' + Math.round(r * 0.22) + 'px)';
    oc2.fill();
    oc2.filter = 'none';

    oc2.beginPath();
    oc2.arc(cx, cy, r, 0, Math.PI * 2);
    oc2.fillStyle = '#ffffff';
    oc2.fill();

    const shade = oc2.createRadialGradient(
      cx + r * 0.25, cy + r * 0.30, r * 0.1,
      cx - r * 0.10, cy - r * 0.10, r * 1.05
    );
    shade.addColorStop(0,    'rgba(255,255,255,0)');
    shade.addColorStop(0.55, 'rgba(180,205,220,0)');
    shade.addColorStop(0.80, 'rgba(100,140,170,0.22)');
    shade.addColorStop(1,    'rgba(60,100,140,0.52)');
    oc2.beginPath();
    oc2.arc(cx, cy, r, 0, Math.PI * 2);
    oc2.fillStyle = shade;
    oc2.fill();

    const spec = oc2.createRadialGradient(
      cx - r * 0.35, cy - r * 0.35, 0,
      cx - r * 0.35, cy - r * 0.35, r * 0.50
    );
    spec.addColorStop(0,    'rgba(255,255,255,0.90)');
    spec.addColorStop(0.45, 'rgba(255,255,255,0.30)');
    spec.addColorStop(1,    'rgba(255,255,255,0)');
    oc2.beginPath();
    oc2.arc(cx, cy, r, 0, Math.PI * 2);
    oc2.fillStyle = spec;
    oc2.fill();

    const entry = { canvas: oc, half: sizeCss / 2 };
    _sphereCache.set(key, entry);
    return entry;
  }

  Sphere.prototype.draw = function () {
    const { canvas: oc, half } = getSphereCanvas(this.r);
    
    ctx.drawImage(
      oc,
      this.x - half, this.y - half,
      half * 2, half * 2
    );
  };

  Sphere.prototype.update = function (ts) {
    const t = ts * 0.001; 
    this.x = this.baseX + Math.sin(t * this.freqX * Math.PI * 2 + this.phaseX) * this.ampX;
    this.y = this.baseY + Math.sin(t * this.freqY * Math.PI * 2 + this.phaseY) * this.ampY;
  };

  function init() {
    resize();
    spheres = [];
    for (let i = 0; i < TOTAL; i++) spheres.push(new Sphere(i));
    spheres.sort((a, b) => a.r - b.r);
  }

  let raf, lastFrameTs = 0;
  const TARGET_FPS = 30, FRAME_MS = 1000 / TARGET_FPS;

  function loop(ts) {
    raf = requestAnimationFrame(loop);
    if (ts - lastFrameTs < FRAME_MS) return; 
    lastFrameTs = ts;
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = '#CBD8E0';
    ctx.fillRect(0, 0, W, H);
    spheres.forEach(s => { s.update(ts); s.draw(); });
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { cancelAnimationFrame(raf); raf = null; }
    else if (!raf) raf = requestAnimationFrame(loop);
  });

  const canvasObserver = new IntersectionObserver(entries => {
    const visible = entries[0].isIntersecting;
    if (!visible && raf) { cancelAnimationFrame(raf); raf = null; }
    else if (visible && !raf) raf = requestAnimationFrame(loop);
  }, { threshold: 0 });
  canvasObserver.observe(canvas);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => { _sphereCache.clear(); init(); }, 150);
  });
  init();
  raf = requestAnimationFrame(loop);
})();

(function () {
  const content = document.querySelector('.hero__content');
  const hero    = document.querySelector('.hero');
  if (!content || !hero) return;

  const DISABLE_MAX_WIDTH = 1190;

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function onScroll() {
    if (window.innerWidth <= DISABLE_MAX_WIDTH) {
      content.style.transform = '';
      content.style.opacity = '';
      return;
    }

    const scrollY   = window.scrollY;
    const heroH     = hero.offsetHeight;
    const textZone  = heroH * 4;

    const t = clamp(scrollY / textZone, 0, 1);
    content.style.transform = `translateY(-${t * 60}px)`;
    content.style.opacity   = 1 - t;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();

(function () {
  const content = document.querySelector('.about__inner');
  const about   = document.querySelector('.about');
  const hero    = document.querySelector('.hero');
  if (!content || !about) return;

  const DISABLE_MAX_WIDTH = 1190;

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  let sectionTop = hero ? hero.offsetHeight : 0;
  let aboutH     = about.offsetHeight;

  function cacheMetrics() {
    sectionTop = hero ? hero.offsetHeight : 0;
    aboutH     = about.offsetHeight;
  }

  function onScroll() {
    if (window.innerWidth <= DISABLE_MAX_WIDTH) {
      content.style.transform = '';
      content.style.opacity = '';
      return;
    }

    const scrollY  = window.scrollY;
    const textZone = aboutH * 4;

    const t = clamp((scrollY - sectionTop) / textZone, 0, 1);
    content.style.transform = `translateY(-${t * 60}px)`;
    content.style.opacity   = 1 - t;
  }

  let resizeAboutTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeAboutTimer);
    resizeAboutTimer = setTimeout(() => { cacheMetrics(); onScroll(); }, 150);
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

(function () {
  const content = document.querySelector('.svc2-hero__inner');
  const hero    = document.querySelector('.svc2-hero');
  if (!content || !hero) return;

  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function onScroll() {
    const scrollY   = window.scrollY;
    const heroH     = hero.offsetHeight;
    const textZone  = heroH * 0.5;

    const t = clamp(scrollY / textZone, 0, 1);
    content.style.transform = `translateY(-${t * 60}px)`;
    content.style.opacity   = 1 - t;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

(function () {
  const nav = document.getElementById('nav');
  if (!nav) return;

  const footer = document.querySelector('.footer');
  const navAside = document.getElementById('navAside');
  const darkSections = ['#services', '#ai'];
  const darkEls = darkSections.map(s => document.querySelector(s)).filter(Boolean);

  function update() {
    const scrollY = window.scrollY;
    const scrolled = scrollY > 40;
    nav.classList.toggle('scrolled', scrolled);
    if (navAside) navAside.classList.toggle('scrolled', scrolled);

    const mid = scrollY + 28;
    let inDark = false;
    darkEls.forEach(el => {
      if (el.offsetTop <= mid && el.offsetTop + el.offsetHeight > mid) inDark = true;
    });
    nav.classList.toggle('dark', inDark);

    let hideNav = false;
    if (footer) {
      const footerTop = footer.offsetTop;
      // se oculta cuando el nav (que está fijo arriba) llegaría a solaparse con el footer
      hideNav = scrollY + 56 >= footerTop; // 56 = altura del nav (.nav { height: 56px })
    }
    nav.classList.toggle('nav--hidden', hideNav);
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();

(function () {
  const wrap = document.getElementById('langSwitch');
  if (!wrap) return;

  const btn = document.getElementById('langBtn');
  const menu = document.getElementById('langMenu');
  const options = Array.from(menu.querySelectorAll('li'));

  function close() {
    wrap.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  }

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = wrap.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', String(isOpen));
  });

  options.forEach(opt => {
    opt.addEventListener('click', () => {
      options.forEach(o => {
        o.classList.toggle('is-selected', o === opt);
        o.setAttribute('aria-selected', String(o === opt));
      });
      btn.textContent = opt.dataset.lang.toUpperCase();
      close();
    });
  });

  document.addEventListener('click', (e) => {
    if (!wrap.contains(e.target)) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();

(function () {
  const links = document.querySelectorAll('.nav__links a[href]');
  if (!links.length) return;

  const currentPath = window.location.pathname.replace(/\/index\.html$/, '/');

  links.forEach(link => {
    const linkPath = link.getAttribute('href').split('#')[0];
    if (linkPath && linkPath !== '/' && linkPath === currentPath) {
      link.classList.add('nav__link--active');
    }
  });
})();

(function () {
  const section = document.querySelector('.testimonials');
  if (!section) return;

  const DATA_es = [
    {
      lines: [
        '"Llevamos muchos años trabajando con Levenant',
        'en el diseño de nuestra identidad corporativa,',
        'y en la creación de una imagen que nos ayuda',
        'a conectar con nuestros clientes."'
      ],
      name: 'Pablo Obiol', company: 'Marketing Director'
    },
    {
      lines: [
        '“Levenant ha aportado creatividad, dedicación',
        'y una enorme sensibilidad a muchos de nuestros',
        'proyectos y campañas. El trabajo de Iván ha',
        'ayudado a dar visibilidad a nuestra misión y a',
        'las familias que apoyamos, formando parte de',
        'la historia de la Casa Ronald McDonald de Valencia.”',
      ],
      name: 'Ana Belén Díaz', company: 'Gerente de la Casa Ronald McDonald de Valencia'
    },
    {
      lines: [
        '"Estamos satisfechos con el servicio prestado. ',
        'El equipo fue profesional, cumplió con los plazos',
        'de entrega, entendió bien nuestras necesidades',
        'y adoptó un enfoque proactivo, ofreciendo',
        'consejos valiosos y priorizando las tareas de forma eficaz.',
        'Su fiabilidad y compromiso los han convertido en un socio de confianza."'
      ],
      name: 'Jordi Millastre', company: 'Marketing & Communication Manager'
    },
    {
      lines: [
        '“Ingeniosos, rápidos y eficaces. ',
        'Trabajamos muy a gusto con Levenant;',
        'la comunicación es muy fluida, y su dedicación',
        'y atención personalizada están entre',
        'sus puntos fuertes. ¡Enhorabuena, los recomendamos totalmente!”'
      ],
      name: 'Mar Dols', company: 'CEO FerreteriaDols'
    },
    {
      lines: [
        '“¡Excelentes profesionales! Es un placer trabajar',
        'con personas comprometidas y preocupadas por',
        'la satisfacción del cliente, y que muestran una constante',
        'disposición a ayudar. Después de muchos años de relación',
        'laboral, ¡puedo recomendarlos totalmente!”'
      ],
      name: 'Denise Kupervaser', company: 'Casa Montaña'
    }
  ];

  const DATA_en = [
    {
      lines: [
        '"We have been working with Levenant for many years',
        'on the design of our corporate identity,',
        'and in creating an image that helps us',
        'connect with our clients."'
      ],
      name: 'Pablo Obiol', company: 'Marketing Director'
    },
    {
      lines: [
        '“Levenant has brought creativity, dedication,',
        'and enormous sensitivity to many of our',
        'projects and campaigns. Iván\'s work has',
        'helped give visibility to our mission and to',
        'the families we support, becoming part of',
        'the story of the Ronald McDonald House of Valencia.”',
      ],
      name: 'Ana Belén Díaz', company: 'Manager of the Ronald McDonald House of Valencia'
    },
    {
      lines: [
        '"We are satisfied with the service provided. ',
        'The team was professional, met delivery deadlines,',
        'understood our needs well, and took',
        'a proactive approach by offering valuable advice',
        'and prioritizing tasks effectively.',
        'Their reliability and commitment have made them a trusted partner."'
      ],
      name: 'Jordi Millastre', company: 'Marketing & Communication Manager'
    },
    {
      lines: [
        '“Resourceful, quick, and effective. ',
        'We work very comfortably with Levenant;',
        'communication is very smooth, and their dedication',
        'and personalized attention are among',
        'their strengths. Congratulations, we highly recommend them!”'
      ],
      name: 'Mar Dols', company: 'CEO FerreteriaDols'
    },
    {
      lines: [
        '“Excellent professionals! It\'s a pleasure to work',
        'with people who are committed and concerned about',
        'customer satisfaction, and who show a constant',
        'willingness to help. After many years of working',
        'relationship, I can highly recommend them!”'
      ],
      name: 'Denise Kupervaser', company: 'Casa Montaña'
    }
  ];

  const isEs = location.pathname.startsWith('/es/') || location.pathname === '/es';
  const DATA = isEs ? DATA_es : DATA_en;

  const N           = DATA.length;
  const STAGGER_IN  = 90;   
  const STAGGER_OUT = 50;   
  const DUR_IN      = 800;  
  const DUR_OUT     = 400;  

  function fullQuote(d) { return d.lines.join(' '); }

  const sliderWrap = document.createElement('div');
  sliderWrap.className = 'ts-slider-wrap';
  sliderWrap.innerHTML = `
    <div class="ts-ghost ts-ghost--prev"><p class="ts-ghost__quote"></p><span class="ts-ghost__author"></span></div>
    <div class="ts-ghost ts-ghost--next"><p class="ts-ghost__quote"></p><span class="ts-ghost__author"></span></div>
    <div class="ts-viewport">
      ${DATA.map((_, i) => `<div class="ts-slide" data-index="${i}"></div>`).join('')}
    </div>
    <p class="ts-author">
      <span class="ts-author-name"></span><span class="ts-author-sep"> — </span><span class="ts-author-company"></span>
    </p>
    <div class="ts-nav">
      ${DATA.map((_, i) =>
        `<button class="ts-dot${i === 0 ? ' active' : ''}" data-index="${i}" aria-label="Slide ${i + 1}">${String(i + 1).padStart(2, '0')}</button>`
      ).join('')}
    </div>
    <button class="ts-pause" title="Pausar autoplay" style="display:none;">⏸</button>`;
  section.appendChild(sliderWrap);

  const viewport  = sliderWrap.querySelector('.ts-viewport');
  const slides    = Array.from(sliderWrap.querySelectorAll('.ts-slide'));
  const authorEl  = sliderWrap.querySelector('.ts-author');
  const nameEl    = sliderWrap.querySelector('.ts-author-name');
  const compEl    = sliderWrap.querySelector('.ts-author-company');
  const dots      = Array.from(sliderWrap.querySelectorAll('.ts-dot'));
  const pauseBtn  = sliderWrap.querySelector('.ts-pause');
  const ghostPrev = sliderWrap.querySelector('.ts-ghost--prev');
  const ghostNext = sliderWrap.querySelector('.ts-ghost--next');

  function buildLines(slideEl, lines) {
    slideEl.innerHTML = lines.map(line =>
      `<div class="ts-line"><div class="ts-line-inner">${line}</div></div>`
    ).join('');
  }

  buildLines(slides[0], DATA[0].lines);
  slides[0].style.cssText = 'position:static; opacity:1;';
  viewport.style.height = slides[0].offsetHeight + 'px';
  slides[0].style.cssText = 'position:absolute;top:0;left:0;width:100%;opacity:1;z-index:1;';

  function animIn(slideEl) {
    const inners = slideEl.querySelectorAll('.ts-line-inner');
    inners.forEach(el => {
      el.style.transition = 'none';
      el.style.transform  = 'translateY(110%)';
    });
    slideEl.getBoundingClientRect();
    requestAnimationFrame(() => {
      inners.forEach((el, i) => {
        el.style.transition = `transform ${DUR_IN}ms cubic-bezier(.14,1,.34,1) ${i * STAGGER_IN}ms`;
        el.style.transform  = 'translateY(0)';
      });
    });
  }

  function animOut(slideEl) {
    slideEl.querySelectorAll('.ts-line-inner').forEach((el, i) => {
      el.style.transition = `transform ${DUR_OUT}ms cubic-bezier(.4,0,1,1) ${i * STAGGER_OUT}ms`;
      el.style.transform  = 'translateY(-110%)';
    });
  }

  function setGhostContent(el, d) {
    el.querySelector('.ts-ghost__quote').textContent  = fullQuote(d);
    el.querySelector('.ts-ghost__author').textContent = `${d.name} — ${d.company}`;
  }

  function updateGhosts(animate) {
    const pi = (current - 1 + N) % N;
    const ni = (current + 1) % N;
    if (animate) {
      ghostPrev.style.opacity = '0';
      ghostNext.style.opacity = '0';
      setTimeout(() => {
        setGhostContent(ghostPrev, DATA[pi]);
        setGhostContent(ghostNext, DATA[ni]);
        ghostPrev.style.opacity = '';
        ghostNext.style.opacity = '';
      }, 240);
    } else {
      setGhostContent(ghostPrev, DATA[pi]);
      setGhostContent(ghostNext, DATA[ni]);
    }
  }

  function updateAuthor(animate) {
    const d = DATA[current];
    if (animate) {
      authorEl.classList.remove('visible');
      setTimeout(() => {
        nameEl.textContent = d.name;
        compEl.textContent = d.company;
        authorEl.classList.add('visible');
      }, 360);
    } else {
      nameEl.textContent = d.name;
      compEl.textContent = d.company;
    }
  }

  let current = 0, busy = false, timer, paused = false;

  function go(idx) {
    if (busy || idx === current) return;
    busy = true;

    const outIdx = current;
    current      = idx;

    animOut(slides[outIdx]);

    const overlap = 160;
    setTimeout(() => {
      buildLines(slides[current], DATA[current].lines);
      slides[current].style.opacity = '1';
      slides[current].style.zIndex  = '2';
      slides[outIdx].style.zIndex   = '1';
      animIn(slides[current]);
    }, overlap);

    const outEnd = (DATA[outIdx].lines.length - 1) * STAGGER_OUT + DUR_OUT + 60;
    setTimeout(() => {
      slides[outIdx].style.opacity = '0';
      slides[outIdx].style.zIndex  = '0';
    }, outEnd);

    updateAuthor(true);
    updateGhosts(true);
    dots.forEach((d, i) => d.classList.toggle('active', i === current));

    const inEnd = overlap + (DATA[current].lines.length - 1) * STAGGER_IN + DUR_IN + 100;
    setTimeout(() => { busy = false; }, inEnd);
  }

  dots.forEach(dot => dot.addEventListener('click', () => {
    clearInterval(timer);
    go(+dot.dataset.index);
    startTimer();
  }));

  pauseBtn.addEventListener('click', () => {
    paused = !paused;
    pauseBtn.textContent = paused ? '▶' : '⏸';
    pauseBtn.title = paused ? 'Reanudar autoplay' : 'Pausar autoplay';
    paused ? clearInterval(timer) : startTimer();
  });

  function startTimer() {
    clearInterval(timer);
    if (!paused) timer = setInterval(() => go((current + 1) % N), 7000);
  }

  slides.slice(1).forEach(s => {
    s.style.cssText = 'position:absolute;top:0;left:0;width:100%;opacity:0;z-index:0;';
  });

  updateAuthor(false);
  updateGhosts(false);
  authorEl.classList.add('visible');
  animIn(slides[0]);
  startTimer();
})();

(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(max-width: 767px)').matches) return;
  function wrapChars(el) {
    el.innerHTML = el.innerHTML
      .split(/(<br\s*\/?>)/gi)
      .map(part => /<br/i.test(part) ? part :
        part.split('').map(ch =>
          ch === ' ' ? ' ' : `<span class="t-char">${ch}</span>`
        ).join('')
      ).join('');
  }

  function fireChars(el, baseDelay = 0) {
    const chars = el.querySelectorAll('.t-char');
    chars.forEach((c, i) =>
      setTimeout(() => c.classList.add('on'), baseDelay + i * 32)
    );
    return chars.length * 32; 
  }

  function fireFade(els, delay) {
    els.forEach(el => setTimeout(() => el.classList.add('on'), delay));
  }

  document.querySelectorAll('.hero .hero__title, .about__heading, .services__heading, .ai-block__heading')
    .forEach(wrapChars);

  document.querySelectorAll(
    '.hero .hero__sub, .hero .btn-standard, ' +
    '.about__body p, .services__desc, .ai-block__desc, ' +
    '.services__col h3, .services__col li, .ai-block__col-title, .ai-block__list li'
  ).forEach(el => el.classList.add('t-fade'));

  const sections = [
    { root: '.hero',       heading: '.hero .hero__title',  fade: ['.hero .hero__sub', '.hero .btn-standard'] },
    { root: '.about',     heading: '.about__heading',     fade: ['.about__body p'] },
    { root: '.services',  heading: '.services__heading',  fade: ['.services__desc', '.services__col h3', '.services__col li'] },
    { root: '.ai-block',  heading: '.ai-block__heading',  fade: ['.ai-block__desc', '.ai-block__col-title', '.ai-block__list li'] },
  ];

  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);

      const sec = sections.find(s => e.target.matches(s.root));
      if (!sec) return;

      const headingEl = document.querySelector(sec.heading);
      if (!headingEl) return;

      const typingDuration = fireChars(headingEl, 0);

      const fadeEls = sec.fade.flatMap(sel => Array.from(document.querySelectorAll(sel)));
      fireFade(fadeEls, typingDuration * 0.5); 
    });
  }, { threshold: 0.25 });

  sections.forEach(s => {
    const el = document.querySelector(s.root);
    if (el) io.observe(el);
  });
})();

document.querySelector('.footer__lang-btn')?.addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

(function () {
  
  const DEFS = [
    { sel: '.about',     from: [241,239,226], to: [42, 54, 40]   },
    /*{ sel: '.services',  from: [42, 54, 40],  to: [241,239,226]  },*/
    /*{ sel: '.portfolio', from: [241,239,226], to: [42, 54, 40]   },*/
    /*{ sel: '.ai-block',      from: [42, 54, 40],  to: [241,239,226]  },*/
  ];

  function lerp(a, b, t) { return Math.round(a + (b - a) * t); }
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  const sections = DEFS.map(({ sel, from, to }) => {
    const el = document.querySelector(sel);
    if (!el) return null;
    const wrap = document.createElement('div');
    wrap.className = 'scroll-content-wrap';
    while (el.firstChild) wrap.appendChild(el.firstChild);
    el.appendChild(wrap);
    return { el, wrap, from, to };
  }).filter(Boolean);

  let sectionMetrics = [];

  function cacheSectionMetrics() {
    sectionMetrics = sections.map(({ el, wrap, from, to }) => ({
      el, wrap, from, to,
      top: el.offsetTop,
      height: el.offsetHeight,
    }));
  }

  const DISABLE_MAX_WIDTH = 1190;

  function onScroll() {
    const scrollY = window.scrollY;
    const disableTextEffect = window.innerWidth <= DISABLE_MAX_WIDTH;

    sectionMetrics.forEach(({ el, wrap, from, to, top, height }) => {
      const transZone  = height * 0.45;
      const transStart = top + height - transZone;
      const t = clamp((scrollY - transStart) / transZone, 0, 1);

      el.style.backgroundColor =
        `rgb(${lerp(from[0],to[0],t)},${lerp(from[1],to[1],t)},${lerp(from[2],to[2],t)})`;

      if (disableTextEffect) {
        wrap.style.transform = '';
        wrap.style.opacity = '';
      } else {
        wrap.style.transform = `translateY(${-t * 70}px)`;
        wrap.style.opacity   = String(1 - t * 0.85);
      }
    });
  }

  cacheSectionMetrics();
  let resizeParallaxTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeParallaxTimer);
    resizeParallaxTimer = setTimeout(() => { cacheSectionMetrics(); onScroll(); }, 150);
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();










document.addEventListener('DOMContentLoaded', function () {
	const breakpoint = 1150;

	const nav = document.querySelector('.nav');
	const navLinksBox = document.querySelector('.nav__links_box');
	const burger = document.querySelector('.nav__burger');

	if (!nav || !navLinksBox || !burger) return;

	// Marcador invisible para recordar la posición original exacta
	const placeholder = document.createComment('posición original de nav__links_box');
	nav.insertBefore(placeholder, navLinksBox);

	function moverMenuResponsive() {
		if (window.innerWidth <= breakpoint) {
			// Mover nav__links_box al principio del body
			if (navLinksBox.parentElement !== document.body) {
				document.body.insertBefore(navLinksBox, document.body.firstElementChild);
			}
		} else {
			// Devolver nav__links_box a su sitio original dentro de .nav
			if (navLinksBox.parentElement !== nav) {
				nav.insertBefore(navLinksBox, placeholder.nextSibling);
			}

			// Opcional: cerrar el menú al volver a escritorio
			navLinksBox.classList.remove('resp-abierto');
		}
	}

	// Ejecutar al cargar
	moverMenuResponsive();

	// Ejecutar al cambiar tamaño
	window.addEventListener('resize', moverMenuResponsive);

	// Abrir/cerrar menú responsive
	burger.addEventListener('click', function () {
		navLinksBox.classList.toggle('resp-abierto');
	});
});